import React from 'react';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';

import './standalone-cart-history-header.scss';

const StandaloneCartHistoryHeader = ({ onPressBack }) => {
      return (
            <div className='standalone-cart-history-header'>
                  <div className="back-button-container">
                        <button className="back-btn" onClick={onPressBack}>
                              <div className="back-btn-icon">
                                    <ArrowBackIcon />
                              </div>
                        </button>
                        <span className="header-title">Standalone carts</span>
                  </div>
            </div>
      )
}

export default StandaloneCartHistoryHeader;
